import { tree } from "d3"

// Synopsis keys must correspond to backend SynopsisModel properties
export const CORE_ENTITIES = {
  BOARD_ROLES: {
    key: "boardRoles",
    min: 28000,
    max: 30000,
    bad: true, // bad if not within range
  },
  COMMITTEE_ROLES: {
    key: "committeeRoles",
    min: 3000,
    max: 4000,
    bad: true, // bad if not within range
  },
  FTSE100_COMPANIES: {
    key: "ftse100Companies",
    min: 100,
    max: 100,
    info: true, // info if not exact
    bad: null, // null means warn only
  },
  FTSE100_COMPANIES_FAIL: {
    key: "ftse100Companies",
    min: 98,
    max: 102,
    info: true, // info if not exact
    bad: true, // null means warn only
  },
  FTSE250_COMPANIES: {
    key: "ftse250Companies",
    min: 250,
    max: 250,
    info: true, // info if not exact
    bad: null, // null means warn only
  },
  NEWS: {
    key: "news",
    min: 5000,
    max: 50000,
    bad: true, // bad if too low
  },
  PEOPLE_BOARD: {
    key: "peopleBoard",
    min: 20000,
    max: 22000,
    bad: true, // bad if not within range
  },
  PEOPLE_COMMITTEES: {
    key: "peopleCommittees",
    min: 2500,
    max: 3500,
    bad: true, // bad if not within range
  },
  TOTAL_COMPANIES: {
    key: "totalLseCompanies",
    min: 1000,
    max: 1200,
    bad: true, // bad if not within range
  },
}

export const TIME_STAMPS = {
  LAST_UPDATED: {
    key: "lastUpdated",
    min: new Date(),
    max: null,
    bad: true, // bad if not up to date
  },
  COMPANY_ENTITIES_LAST_UPDATED: {
    key: "companyEntitiesLastUpdated",
    min: new Date(),
    max: null,
    bad: true, // bad if not up to date
  },
}

export const DATA_SANITY_CHECKS = {
  UNKNOWN_GENDER: {
    key: "unknownGender",
    min: 0,
    max: 0,
  },
  UNKNOWN_ROLE: {
    key: "unknownRole",
    min: 0,
    max: 0,
  },
  NOT_ONE_CHAIR: {
    key: "notOneChair",
    min: 0,
    max: 0,
  },
  MORE_THAN_ONE_CEO: {
    key: "moreThanOneCeo",
    min: 0,
    max: 0,
  },
  MORE_THAN_ONE_CFO: {
    key: "moreThanOneCfo",
    min: 0,
    max: 0,
  },
  MORE_THAN_ONE_SID: {
    key: "moreThanOneSid",
    min: 0,
    max: 0,
  },
  NOT_ONE_AUDIT_CHAIR: {
    key: "notOneAuditChair",
    min: 0,
    max: 0,
  },
}

const API_CALL_DEFAULTS = {
  STATUS: {
    key: "status",
    min: 200,
    max: 200,
    bad: true // bad if not 200 (status OK from backend)
  },
  RESPONSE_TIME: {
    key: "responseTime",
    min: 0,
    max: 1.0,
    bad: true
  },
  COUNT: {
    key: "count",
    bad: true
  },
};

export const API_CALLS = {
  CLUB350: {
    ID: "350Club",
    COMPANIES: {
      STATUS: { ...API_CALL_DEFAULTS.STATUS },
      RESPONSE_TIME: { ...API_CALL_DEFAULTS.RESPONSE_TIME },
      COUNT: { ...API_CALL_DEFAULTS.COUNT, min: 350, max: 350 },
      // INFO: {title: "Companies Api Call"},
    },
    NEWS_META: {
      STATUS: { ...API_CALL_DEFAULTS.STATUS },
      RESPONSE_TIME: { ...API_CALL_DEFAULTS.RESPONSE_TIME },
      COUNT: { ...API_CALL_DEFAULTS.COUNT, min: 1000, max: 10000 },
    },
    NEWS_RELEASE: {
      STATUS: { ...API_CALL_DEFAULTS.STATUS },
      RESPONSE_TIME: { ...API_CALL_DEFAULTS.RESPONSE_TIME },
      COUNT: { ...API_CALL_DEFAULTS.COUNT, min: 1, max: 10 },
    },
  },

  NUMERABLE: {
    ID: "Numerable",
    COMPANIES: {
      STATUS: { ...API_CALL_DEFAULTS.STATUS },
      RESPONSE_TIME: { ...API_CALL_DEFAULTS.RESPONSE_TIME },
      COUNT: { ...API_CALL_DEFAULTS.COUNT, min: 350, max: 350 },
      // INFO: {title: "Companies Api Call"},
    },
    NEWS_META: {
      STATUS: { ...API_CALL_DEFAULTS.STATUS },
      RESPONSE_TIME: { ...API_CALL_DEFAULTS.RESPONSE_TIME },
      COUNT: { ...API_CALL_DEFAULTS.COUNT, min: 4500, max: 10000 },
    },
    NEWS_RELEASE: {
      STATUS: { ...API_CALL_DEFAULTS.STATUS },
      RESPONSE_TIME: { ...API_CALL_DEFAULTS.RESPONSE_TIME },
      COUNT: { ...API_CALL_DEFAULTS.COUNT, min: 1, max: 10 },
    },
  }
}

// export const API_CALLS = {
// COMPANIES_API_CALLS: {
//   STATUS: { ...API_CALL_DEFAULTS.STATUS },
//   RESPONSE_TIME: { ...API_CALL_DEFAULTS.RESPONSE_TIME },
//   COUNT: { ...API_CALL_DEFAULTS.COUNT, min: 350, max: 350 },
//   // INFO: {title: "Companies Api Call"},
// },
// NEWS_META_API_CALLS: {
//   STATUS: { ...API_CALL_DEFAULTS.STATUS },
//   RESPONSE_TIME: { ...API_CALL_DEFAULTS.RESPONSE_TIME },
//   COUNT: { ...API_CALL_DEFAULTS.COUNT, min: 1000, max: 10000 },
// },
// NEWS_RELEASE_API_CALLS: {
//   STATUS: { ...API_CALL_DEFAULTS.STATUS },
//   RESPONSE_TIME: { ...API_CALL_DEFAULTS.RESPONSE_TIME },
//   COUNT: { ...API_CALL_DEFAULTS.COUNT, min: 1, max: 10 },
// },
// }

// export const NUMERABLE_API_CALLS = {
//   COMPANIES: {
//     STATUS: { ...API_CALL_DEFAULTS.STATUS },
//     RESPONSE_TIME: { ...API_CALL_DEFAULTS.RESPONSE_TIME },
//     COUNT: { ...API_CALL_DEFAULTS.COUNT, min: 350, max: 350 },
//     // INFO: {title: "Companies Api Call"},
//   },
//   NEWS_META: {
//     STATUS: { ...API_CALL_DEFAULTS.STATUS },
//     RESPONSE_TIME: { ...API_CALL_DEFAULTS.RESPONSE_TIME },
//     COUNT: { ...API_CALL_DEFAULTS.COUNT, min: 5000, max: 10000 },
//   },
//   NEWS_RELEASE: {
//     STATUS: { ...API_CALL_DEFAULTS.STATUS },
//     RESPONSE_TIME: { ...API_CALL_DEFAULTS.RESPONSE_TIME },
//     COUNT: { ...API_CALL_DEFAULTS.COUNT, min: 1, max: 10 },
//   },
// }
